import type { ColoredMaterialResult } from "@color-finder/color-finder-api/src/models/colored-material";
import styled from "@emotion/styled";
import {
  Box,
  Button,
  CircularProgress,
  Stack,
  Typography,
} from "@mui/material";
import { UnauthenticationDialog } from "components/dialog/UnauthenticationDialog";
import type { FilterEntry } from "hooks/filters";
import type { CdcUserAttributes } from "models/cdcUser";
import React from "react";
import { useNavigate } from "react-router-dom";
import { getDataFromLocalstorageByKey } from "service/utils/get-data-localstorage";
import LockIcon from "../../assets/imgs/LockIcon.png";
import { logCustomEvent } from "../../datadog";

const LockIconPath = styled.img({
  height: "12.5px",
  width: "11px",
});

interface SearchButton {
  isLogin: boolean;
  isLoading?: boolean;
  error?: any;
  result?: ColoredMaterialResult;
  filters?: Array<FilterEntry>;
}

export const SearchButtonAuthen = ({
  isLogin,
  isLoading = false,
  error,
  result,
  filters,
}: SearchButton) => {
  const [openCheckAuth, setOpenCheckAuth] = React.useState(false);

  const cdcUser: CdcUserAttributes | undefined =
    getDataFromLocalstorageByKey("cdcUser") ?? undefined;

  const navigate = useNavigate();

  const handleOpenSearchPage = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    logCustomEvent("search-start", {
      filter_count: filters?.length ?? 0,
      authenticated: Boolean(isLogin || cdcUser),
    });
    if (!isLogin && !cdcUser) {
      setOpenCheckAuth(true);
    } else {
      setOpenCheckAuth(false);
      navigate("/search", { state: { filters } });
    }
  };

  return (
    <Box
      sx={{
        textAlign: "center",
        width: "100%",
        backgroundColor: "#fff",
        paddingBottom: "30px",
      }}
    >
      <Button
        id="LDPageSearchBtn"
        data-cy={"LDPageSearchBtn"}
        sx={{
          width: "auto",
          height: "32px",
          margin: "auto",
          borderRadius: "2px",
          whiteSpace: `${error?.message ? "normal" : "nowrap"}`,
        }}
        onClick={handleOpenSearchPage}
        fullWidth
        size="large"
        variant="contained"
      >
        <Stack>
          <Box
            display={"inline-flex"}
            justifyContent="center"
            alignItems="center"
            height={14}
          >
            {!isLogin && !cdcUser && (
              <LockIconPath
                style={{ marginRight: "8px", color: "#fff" }}
                src={LockIcon}
              />
            )}
            Search
            {(isLogin || cdcUser) && (
              <Box ml={"8px"}>
                {isLoading && (
                  <CircularProgress size={14} style={{ color: "white" }} />
                )}
                {result && (
                  <Typography fontWeight="normal" fontSize={12}>
                    {"(" +
                      result.totalCount +
                      " " +
                      (result.totalCount === 1 ? "Result)" : "Results)")}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
          {/* {error &&
                <Typography sx={{marginLeft: "8px"}} fontWeight="normal" fontSize={12}>Failed to load preview: {error.message}</Typography>} */}
        </Stack>
      </Button>
      <UnauthenticationDialog
        isOpen={openCheckAuth}
        onClose={setOpenCheckAuth}
      />
    </Box>
  );
};
